/**
 * ratingLog: the store rating ask explains itself, one line per decision.
 *
 * WHY (2026-10-26): the owner ran a scan on the Galaxy S21+ with a sideloaded
 * release APK and saw no rating sheet. Nothing in the app said which gate had
 * stopped it: the session already spent, the twenty-hour gap, the one ask
 * already made (by the sheet or the old card), a look that never happened on the results
 * surface, the app backgrounded, the moment aged out, or Play declining to
 * show a dialog for a build it did not install. Every one of those now logs
 * one short line, with the reason, through this function.
 *
 * WHERE THE LINE GOES, so it can be read on a device:
 *   - the scan log capture buffer (lib/dexScanLog), so it is in the file
 *     "Export scan log" writes from Settings, whether or not a scan has run;
 *   - the console, which a debug build forwards to Xcode or logcat;
 *   - and on Android the native log under the NexusRating tag
 *     (lib/nexusDiag), because a RELEASE build drops console lines before
 *     they reach logcat: `adb logcat -s NexusRating` is the live view there.
 *
 * Lines are short and carry no trainer data: moments, surfaces, counts and
 * spans only (lib/firstRunPrompts.describeFirstRunBlock writes the gate's).
 */
import { appendDexScanCaptureLine } from "./dexScanLog";
import { nativeLog } from "./nexusDiag";

export const RATING_LOG_PREFIX = "[rating]";
/** The logcat tag on Android: `adb logcat -s NexusRating`. */
export const RATING_LOG_TAG = "NexusRating";

export function ratingLog(line: string): void {
  const text = `${RATING_LOG_PREFIX} ${line}`;
  appendDexScanCaptureLine(text);
  // eslint-disable-next-line no-console
  console.log(text);
  void nativeLog(RATING_LOG_TAG, text);
}
